/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';

import ReactLoading from "react-loading";
import {
  Button,
  InputGroupAddon,
  Input,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { enqueueSnackbar } from 'notistack';
import { PostFetch } from '../../../../services/apiBase';
export default function CprNotes({ cpr_id, open, onClose }) {

  const [newNote, setNewNote] = useState('')
  const user = JSON.parse(localStorage.getItem('user'))

  const [load, setLoad] = useState(false);

  const handleOnCloseModal = () => {
    onClose()
  }

  const handleSubmit = async () => {

    try {
      setLoad(true)

      const response = await PostFetch(`/financial/cpr/notes`,
        {
          "cpr_id": cpr_id,
          "comment": newNote,
          "username": user.username
        });
      
      setNewNote('')
      onClose()

      enqueueSnackbar('Observação salva com sucesso', { variant: 'success' });
      setLoad(false)
    } catch (error) {
      enqueueSnackbar('Erro ao salvar observação', { variant: 'error' });
      setLoad(false)
    }
  }

  return (
    <>
      <Modal size='lg' isOpen={open} toggle={handleOnCloseModal} >
        <ModalHeader toggle={handleOnCloseModal}>Observações</ModalHeader>

        <ModalBody style={{ backgroundColor: "#fff", maxHeight: '600px' }} >
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            marginBottom: '10px'
          }}>
          <InputGroup>
            <InputGroupAddon addonType="prepend">Nova observação:</InputGroupAddon>
            <Input
              type='textarea'
              id="note"
              value={newNote}
              onChange={e => setNewNote(e.target.value)}
            />
          </InputGroup>
          </div>
          
        </ModalBody>
        {load ?
          <ModalFooter style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ReactLoading type='bubbles' color="#feb049" />
          </ModalFooter>
          :
          <ModalFooter style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <Button style={{ marginRight: '5px' }} color="danger" onClick={handleOnCloseModal}>Fechar</Button>
                <Button color="success" disabled={newNote.length <= 0} onClick={() => handleSubmit()}>Salvar</Button>
              </div>
            </div>
          </ModalFooter>
        }
      </Modal>

    </>
  )

}

